(function () {
    'use strict';

    angular.module('swif.publicLightning')
    .config(route);

    route.$inject = ['$routeProvider', 'swifPublicLightningConstant'];
    function route ($routeProvider, constant) {
        $routeProvider.when(constant.request.routes.table_view, {
            templateUrl: 'partials/openstc/requests_table_view.html',
            controller: 'RequestsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPublicLightningService', function (service) {
                    return service.request.resolveData();
                }]
            }
        });
        $routeProvider.when(constant.request.routes.explorer_view, {
            templateUrl: 'partials/openstc/requests_explorer_view.html',
            controller: 'RequestsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPublicLightningService', function (service) {
                    return service.request.resolveData();
                }]
            }
        });
        $routeProvider.when(constant.request.routes.commission_view, {
            templateUrl: 'partials/openstc/requests_commission_view.html',
            controller: 'RequestsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPublicLightningService', function (service) {
                    return service.request.resolveCommissionData();
                }]
            }
        });
    }

})();
